import {
  isHuafendaM98_8KEquipment,
  isHuafendaX87V2Equipment,
} from "./hfdGifLightingDevices";
import {
  isHuafendaX87V2Device,
  isHuafendaX87V2Wireless,
  type HfdX87V2EquipmentLike,
} from "./hfdX87V2";
import {
  isHuafendaX75GcDevice,
  isHuafendaX75GcEquipment,
  isHuafendaX75GcWired,
  type HfdX75GcEquipmentLike,
} from "./hfdX75Gc";
import {
  isHuafendaDk108Device,
  isHuafendaDk108Equipment,
  isHuafendaDk108Wired,
  type HfdDk108EquipmentLike,
} from "./hfdDk108";

export type HfdMechanicalV2LikeEquipmentLike =
  | HfdX87V2EquipmentLike
  | HfdX75GcEquipmentLike
  | HfdDk108EquipmentLike;

/** 华丰达机械轴二代（X87 V2 / X75GC / DK108 / M98 8K）：keyData 读写、律动重连等与 X87 V2 同级 */
export function isHuafendaMechanicalV2LikeDevice(
  eq: HfdMechanicalV2LikeEquipmentLike | null | undefined
): boolean {
  return (
    isHuafendaX87V2Device(eq) ||
    isHuafendaX75GcDevice(eq) ||
    isHuafendaDk108Device(eq) ||
    isHuafendaM98_8KEquipment(eq)
  );
}

export function isHuafendaMechanicalV2LikeEquipment(
  eq: HfdMechanicalV2LikeEquipmentLike | null | undefined
): boolean {
  return (
    isHuafendaX87V2Equipment(eq) ||
    isHuafendaX75GcEquipment(eq) ||
    isHuafendaDk108Equipment(eq) ||
    isHuafendaM98_8KEquipment(eq)
  );
}

/** 有线 USB（不含 2.4G 接收器） */
export function isHuafendaMechanicalV2LikeWiredDevice(
  eq: HfdMechanicalV2LikeEquipmentLike | null | undefined
): boolean {
  if (!eq) return false;
  if (isHuafendaX75GcWired(eq)) return true;
  if (isHuafendaDk108Wired(eq)) return true;
  return isHuafendaX87V2Device(eq) && !isHuafendaX87V2Wireless(eq);
}

export function isHuafendaMechanicalV2LikeWiredEquipment(
  eq: HfdMechanicalV2LikeEquipmentLike | null | undefined
): boolean {
  if (!eq || typeof eq !== "object") return false;
  const provider = String(eq.solutionRovider ?? "")
    .trim()
    .toLowerCase();
  if (provider && provider !== "huafenda") return false;
  return isHuafendaMechanicalV2LikeWiredDevice(eq);
}

/** 出厂 keyData 底座矩阵 keyboardType */
export function resolveHfdMechanicalV2LikeDefaultKeyboardType(
  eq: HfdMechanicalV2LikeEquipmentLike | null | undefined,
  keyboardType?: string
): string {
  const kb = String(keyboardType ?? eq?.keyboardType ?? "").trim();
  if (kb) return kb;
  if (isHuafendaX75GcDevice(eq)) return "x75gc";
  if (isHuafendaDk108Device(eq)) return "DK108";
  if (isHuafendaM98_8KEquipment(eq)) return "M98 8K";
  return "huafenda87";
}
